import * as bootstrap from 'bootstrap'

const registerJqueryPluginBridge = (name, Constructor) => {
  const $ = globalThis.jQuery || globalThis.$
  if (!$ || !$.fn || $.fn[name] || !Constructor || typeof Constructor.getOrCreateInstance !== 'function') return

  const CONFLICTING_OVERLAY = {
    tooltip: 'popover',
    popover: 'tooltip'
  }

  $.fn[name] = function (configOrMethod, ...args) {
    return this.each(function () {
      const oppositeName = CONFLICTING_OVERLAY[name]
      if (oppositeName) {
        const oppositeCtor = $.fn[oppositeName]?.Constructor
        const oppositeInstance = oppositeCtor?.getInstance?.(this)
        if (oppositeInstance) {
          if (typeof configOrMethod === 'string' && typeof oppositeInstance[configOrMethod] === 'function') {
            oppositeInstance[configOrMethod](...args)
          }
          return
        }
      }

      const instance = Constructor.getOrCreateInstance(this, configOrMethod !== null && typeof configOrMethod === 'object' ? configOrMethod : undefined)

      if (typeof configOrMethod === 'string' && typeof instance[configOrMethod] === 'function') {
        instance[configOrMethod](...args)
      }
    })
  }

  $.fn[name].Constructor = Constructor
}

[
  ['alert', bootstrap.Alert],
  ['button', bootstrap.Button],
  ['carousel', bootstrap.Carousel],
  ['collapse', bootstrap.Collapse],
  ['dropdown', bootstrap.Dropdown],
  ['modal', bootstrap.Modal],
  ['offcanvas', bootstrap.Offcanvas],
  ['popover', bootstrap.Popover],
  ['scrollspy', bootstrap.ScrollSpy],
  ['tab', bootstrap.Tab],
  ['toast', bootstrap.Toast],
  ['tooltip', bootstrap.Tooltip]
].forEach(([name, Constructor]) => registerJqueryPluginBridge(name, Constructor))

globalThis.bootstrap = bootstrap
window.bootstrap = bootstrap
